// function openSizePopup(e){let t=document.querySelector("#size-pd-chart");""!=e.trim()?(t.querySelector(".size-pd-chart-content").innerHTML=e,t.classList.add("show"),document.querySelector("body").style.overflow="hidden"):alert("Size chart not found! May be this product has only ONE SIZE.")}function closeSizePopup(){document.querySelector("#size-pd-chart").classList.remove("show"),document.querySelector("body").style.overflow=""}function waitListReuest(e,t,l=null){try{fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",{headers:{accept:"application/json, text/plain, */*","content-type":"application/x-www-form-urlencoded;charset=UTF-8"},body:new URLSearchParams({a:"PAgcrr",email:e,platform:"shopify",variant:t}),method:"POST"}).then((e=>{if(console.log(e),1==e.ok){if(console.log("waitlist true"),null!=l){let e=l.closest(".product-upsell__holder");return e.querySelector(".waitlist-modal_form").classList.add("hidden"),e.querySelector(".waitlist-modal_success").classList.add("show"),void setTimeout((function(){e.querySelector(".waitlist-modal_success").classList.remove("show"),e.querySelector(".email_input").value="",e.querySelector(".waitlist-modal_form").classList.remove("hidden")}),3e3)}document.querySelector(".waitlist-modal_form").classList.add("hidden"),document.querySelector(".waitlist-modal_success").classList.add("show"),setTimeout(closeWaitList,3e3)}})).catch((e=>{console.log(e)}))}catch(e){console.log(e)}}function closeWaitList(){document.querySelector(".waitlist-modal_form").classList.remove("hidden"),document.querySelector(".waitlist-modal_success").classList.remove("show"),document.querySelector(".waitlist-modal-js").querySelector(".email_input").value=""}function mySubmitFunction(e){e.preventDefault();const t=e.target.elements.email.value,l=e.target.elements.id.value;return console.log(t,l),waitListReuest(t,l),!1}function openModalWaitlist(){document.querySelector(".waitlist-modal-js").classList.add("show"),document.querySelector("#btn-waitlist-modal-show-js").classList.add("hidden")}function showAllLinksInDrawer(e){e.closest(".mobile__menu__dropdown").classList.remove("is-hiding")}function changeVariantId(e,t,l){let o=findIdVariantInJson(e,t);l.closest(".product-upsell__holder").querySelector(".varId").value=o,console.log(l.closest(".product-upsell__holder").querySelector(".varId").value),closeWaitListUpsell(l)}function findIdVariantInJson(e,t){let l=null;return e.variants.forEach((e=>{e.option1!==t&&e.option2!==t&&e.option3!==t||(console.log(e.id),l=e.id)})),l}function openWaitListUpsell(e,t,l){try{let o=findIdVariantInJson(e,t),s=l.closest(".product-upsell__holder");s.querySelector(".waitlist-modal-upsell-js").classList.add("show"),console.log(s.querySelector(".variantId_input").value),s.querySelector(".variantId_input").value=o,s.querySelector(".btn--upsell-custom").classList.add("hidden")}catch(e){console.log(e)}try{l.closest(".btn--upsell-mobile").querySelector("button").style.display="none"}catch(e){console.log(e)}}function closeWaitListUpsell(e){try{let t=e.closest(".product-upsell__holder");t.querySelector(".waitlist-modal-upsell-js").classList.remove("show"),t.querySelector(".btn--upsell-custom").classList.remove("hidden"),t.querySelector(".waitlist-modal_form").classList.remove("hidden")}catch(e){console.log(e)}try{e.closest(".btn--upsell-mobile").querySelector("button").style.display="block"}catch(e){console.log(e)}}function mySubmitFunctionUpsell(e,t){e.preventDefault();const l=e.target.elements.email.value,o=e.target.elements.id.value;return console.log(l,o),waitListReuest(l,o,t),!1}function selectChangeVariant(e,t,l){if(console.log(t),t.includes("sold")){let o=t.split(" ")[0];console.log(o),openWaitListUpsell(e,o,l)}else changeVariantId(e,t,l),closeWaitListUpsell(l)}document.querySelector("#size-pd-chart").addEventListener("click",(function(e){!e.target.matches("#size-pd-chart")&&e.target.closest(".show")||closeSizePopup()})),document.querySelectorAll(".sliderow--back").forEach((e=>{e.addEventListener("click",(function(t){t.preventDefault(),e.parentElement.classList.remove("is-visible"),showAllLinksInDrawer(e),e.classList.contains("link_level_next-1")&&document.querySelector(".drawer__menu").querySelectorAll(".sliderow-firstlevel").forEach((e=>{e.classList.remove("is-hiding")})),e.classList.contains("link_level_next-2")&&document.querySelector(".drawer__menu").querySelectorAll(".btn_level-2").forEach((e=>{e.classList.remove("is-hiding-hidden")}))}))})),document.querySelector(".drawer__menu").querySelectorAll(".btn_level-2").forEach((e=>{e.addEventListener("click",(function(){document.querySelector(".drawer__menu").querySelectorAll(".btn_level-2").forEach((e=>{e.classList.add("is-hiding-hidden")}))}))})),document.querySelectorAll(".sliderow-firstlevel").forEach((e=>{e.addEventListener("click",(function(){console.log("click"),document.querySelectorAll(".sliderow-firstlevel").forEach((e=>e.classList.add("is-hiding")))}))}));

(() => {
	const bundleOptionsSelector = '.bundle-products .product .product-variant__options'
	const injectedAttr = 'data-bundle-button-injected'
	const adoricHostSelector = 'adoric-bundle-mark-two'
	const adoricHostAttr = 'data-bundle-shadow-host'
	const shadowObservers = new WeakMap()
	const sizeGuideCache = new Map()
	const sizeGuideRequests = new Map()
	const loadingClass = 'bundle-products__cta-button--loading'
	let domObserver = null

	const sanitizeHandle = (value) => {
		if (!value) {
			return ''
		}

		return value
			.toString()
			.trim()
			.toLowerCase()
			.replace(/[^a-z0-9-]/g, '-')
			.replace(/-+/g, '-')
			.replace(/^-|-$/g, '')
	}

	const extractHandleFromHref = (href) => {
		if (!href) {
			return ''
		}

		let relativeHref = href

		try {
			const url = new URL(href, window.location.origin)
			relativeHref = url.pathname
		} catch (error) {
			// ignore malformed URLs
		}

		const match = relativeHref.match(/\/products\/([^\/?#]+)/i)
		return match ? sanitizeHandle(match[1]) : ''
	}

	const getProductHandle = (productEl) => {
		if (!(productEl instanceof HTMLElement)) {
			return ''
		}

		const attrCandidates = [
			productEl.getAttribute('data-product-handle'),
			productEl.getAttribute('data-handle'),
			productEl.getAttribute('data-product'),
			productEl.dataset?.productHandle,
			productEl.dataset?.handle,
			productEl.dataset?.product
		]

		for (const candidate of attrCandidates) {
			const handle = sanitizeHandle(candidate)
			if (handle) {
				return handle
			}
		}

		const handleInput = productEl.querySelector('input[name="handle"][value]')
		if (handleInput) {
			const handle = sanitizeHandle(handleInput.getAttribute('value'))
			if (handle) {
				return handle
			}
		}

		const productLink = productEl.querySelector('a[href*="/products/"]')
		if (productLink) {
			const handle = extractHandleFromHref(productLink.getAttribute('href'))
			if (handle) {
				return handle
			}
		}

		return ''
	}

	const fetchSizeGuideMarkup = (handle) => {
		const normalizedHandle = sanitizeHandle(handle)
		if (!normalizedHandle) {
			return Promise.resolve('')
		}

		if (sizeGuideCache.has(normalizedHandle)) {
			return Promise.resolve(sizeGuideCache.get(normalizedHandle))
		}

		if (sizeGuideRequests.has(normalizedHandle)) {
			return sizeGuideRequests.get(normalizedHandle)
		}

		const request = fetch(`/products/${encodeURIComponent(normalizedHandle)}?view=size-chart`, { credentials: 'same-origin' })
			.then((response) => {
				if (!response.ok) {
					throw new Error(`Size guide request failed (${response.status})`)
				}

				return response.text()
			})
			.then((html) => {
				const markup = (html || '').trim()
				sizeGuideCache.set(normalizedHandle, markup)
				sizeGuideRequests.delete(normalizedHandle)
				return markup
			})
			.catch((error) => {
				sizeGuideRequests.delete(normalizedHandle)
				throw error
			})

		sizeGuideRequests.set(normalizedHandle, request)
		return request
	}

	const handleButtonClick = async (event) => {
		event.preventDefault()

		const button = event.currentTarget
		const productEl = button.closest('.product')
		const handle = getProductHandle(productEl)

		if (!handle) {
			alert('Не удалось определить товар для size guide')
			return
		}

		button.disabled = true
		button.classList.add(loadingClass)

		try {
			const markup = await fetchSizeGuideMarkup(handle)
			if (markup) {
				openSizePopup(markup)
			} else {
				alert('Размерная сетка недоступна для этого товара')
			}
		} catch (error) {
			console.error('[Bundle Size Guide] Ошибка загрузки', error)
			alert('Не удалось загрузить size guide для этого товара')
		} finally {
			button.disabled = false
			button.classList.remove(loadingClass)
		}
	}

	const createButton = () => {
		const button = document.createElement('button')
		button.type = 'button'
		button.className = 'bundle-products__cta-button'
		button.textContent = 'Size guide'
		button.style = "font-weight: 400;font-size: 16px;line-height: 100%;letter-spacing: 0%;text-decoration: underline;border: none;background-color: transparent;cursor: pointer;color: #000;"
		button.addEventListener('click', handleButtonClick)
		return button
	}

	const collectTargets = (root) => {
		if (!root) {
			return []
		}

		const targets = []

		if (root instanceof Element && root.matches(bundleOptionsSelector)) {
			targets.push(root)
		}

		if (root.querySelectorAll) {
			root.querySelectorAll(bundleOptionsSelector).forEach((target) => targets.push(target))
		}

		return targets
	}

	const ensureButtons = (root = document) => {
		collectTargets(root).forEach((target) => {
			if (target.hasAttribute(injectedAttr)) {
				return
			}

			target.setAttribute(injectedAttr, 'true')
			target.appendChild(createButton())
		})
	}

	const teardownAdoricHost = (host) => {
		const observer = shadowObservers.get(host)
		if (observer) {
			observer.disconnect()
			shadowObservers.delete(host)
		}
	}

	const wireShadowObserver = (host, shadowRoot) => {
		if (!shadowRoot) {
			return
		}

		const currentObserver = shadowObservers.get(host)
		currentObserver?.disconnect?.()

		const observer = new MutationObserver(() => ensureButtons(shadowRoot))
		observer.observe(shadowRoot, { childList: true, subtree: true })
		shadowObservers.set(host, observer)
		ensureButtons(shadowRoot)
	}

	const waitForShadowRoot = (host, attempt = 0) => {
		if (!(host instanceof HTMLElement) || !host.isConnected) {
			teardownAdoricHost(host)
			return
		}

		const shadowRoot = host.shadowRoot
		if (shadowRoot) {
			wireShadowObserver(host, shadowRoot)
			return
		}

		if (attempt > 60) {
			return
		}

		const delay = Math.min(200 + attempt * 50, 1000)
		setTimeout(() => waitForShadowRoot(host, attempt + 1), delay)
	}

	const initAdoricHost = (host) => {
		if (!(host instanceof HTMLElement)) {
			return
		}

		if (!host.hasAttribute(adoricHostAttr)) {
			host.setAttribute(adoricHostAttr, 'true')
		}

		waitForShadowRoot(host)
	}

	const monitorAdoricHosts = (root = document) => {
		if (!root) {
			return
		}

		const hosts = []

		if (root instanceof Element && root.matches(adoricHostSelector)) {
			hosts.push(root)
		}

		if (root.querySelectorAll) {
			root.querySelectorAll(adoricHostSelector).forEach((host) => hosts.push(host))
		}

		hosts.forEach(initAdoricHost)
	}

	const startObserver = () => {
		if (domObserver || !document.body) {
			return
		}

		domObserver = new MutationObserver((mutations) => {
			let needsDomUpdate = false

			for (const mutation of mutations) {
				if (mutation.type !== 'childList') {
					continue
				}

				mutation.addedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) {
						return
					}

					if (node.matches?.(bundleOptionsSelector) || node.querySelector?.(bundleOptionsSelector)) {
						needsDomUpdate = true
					}

					monitorAdoricHosts(node)
				})

				mutation.removedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) {
						return
					}

					if (node.matches?.(adoricHostSelector)) {
						teardownAdoricHost(node)
					}

					node.querySelectorAll?.(adoricHostSelector).forEach(teardownAdoricHost)
				})
			}

			if (needsDomUpdate) {
				ensureButtons()
			}
		})

		domObserver.observe(document.body, { childList: true, subtree: true })
	}

	const hydrateBundles = (root = document) => {
		ensureButtons(root)
		monitorAdoricHosts(root)
	}

	const onReady = () => {
		hydrateBundles()
		startObserver()
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', onReady, { once: true })
	} else {
		onReady()
	}

	document.addEventListener('shopify:section:load', (event) => {
		const sectionRoot = event?.target instanceof HTMLElement ? event.target : document
		hydrateBundles(sectionRoot)
	})

	document.addEventListener('shopify:section:reorder', () => hydrateBundles())

	if (window?.customElements?.whenDefined) {
		window.customElements.whenDefined('adoric-bundle-mark-two').then(() => monitorAdoricHosts())
	}

	
	const stickyNav = document.querySelector('.collection__sticky-nav')
	const collectionNav = document.querySelector('.collection__nav')

	if (stickyNav && collectionNav) {
		let stickyNavPlaceholder = stickyNav.nextElementSibling

		if (!stickyNavPlaceholder || !stickyNavPlaceholder.classList.contains('collection__sticky-nav-placeholder')) {
			stickyNavPlaceholder = document.createElement('div')
			stickyNavPlaceholder.className = 'collection__sticky-nav-placeholder'
			stickyNavPlaceholder.style.width = '100%'
			stickyNavPlaceholder.style.height = '0px'
			stickyNav.parentNode.insertBefore(stickyNavPlaceholder, stickyNav.nextSibling)
		}

		const updateStickyState = () => {
			const isMobile = window.matchMedia
				? window.matchMedia('(max-width: 991px)').matches
				: window.innerWidth <= 991

			if (!isMobile) {
				stickyNavPlaceholder.style.height = '0px'
				stickyNav.classList.remove('collection__sticky-nav--fixed')
				return
			}

			const rect = collectionNav.getBoundingClientRect()
			const isCompletelyGone = rect.bottom <= 0

			if (isCompletelyGone) {
				stickyNavPlaceholder.style.height = `${stickyNav.offsetHeight}px`
				stickyNav.classList.add('collection__sticky-nav--fixed')
			} else {
				stickyNavPlaceholder.style.height = '0px'
				stickyNav.classList.remove('collection__sticky-nav--fixed')
			}
		}

		updateStickyState()
		window.addEventListener('scroll', updateStickyState)
		window.addEventListener('resize', updateStickyState)
	}
})()



function tabBtns() {
	try {
		const tabBtns = document.querySelectorAll('.more-tabs__btns')
		tabBtns.forEach(b => {
			b.addEventListener('click', () => {
				tabBtns.forEach(btn => {
					btn.classList.remove('active')
				})
				b.classList.add('active')

				let type = b.getAttribute('data-sanitized-tabstype')

				if (!type) {
					type = b.getAttribute('tabstype')
				}

				const tabs = document.querySelectorAll('.tab-sizeguide')
				tabs.forEach(t => {
					t.style.display = "none"

					console.log(t.getAttribute('typetable'), type)

					if (t.getAttribute('typetable') == type || t.getAttribute('data-sanitized-typetable') == type) {
						t.style.display = "block"
					}
				})

			})
		})
	} catch (err) {
		console.log(err)
	}
}


function SizeGuideOpenPage(parentSelector) {
	try {
		const form = document.querySelector(parentSelector).querySelector('.size-guides__form-selector')
		if (!form) return
		form.addEventListener('change', function (event) {
			if (event.target.type === 'radio') {
				const selectedValue = event.target.value
				console.log(`Selected unit: ${selectedValue}`)

				const closestWrap = form.closest('.size-guides-wrapper')
				if (closestWrap) {

					let guidTypeAtr = closestWrap.querySelectorAll('[size-guide-type]')

					if (guidTypeAtr.length == 0) {
						guidTypeAtr = closestWrap.querySelectorAll('[data-sanitized-size-guide-type]')
					}
					console.log(guidTypeAtr)

					guidTypeAtr.forEach(element => {
						let sizeGuideType = element.getAttribute('size-guide-type')

						if (!sizeGuideType) {
							sizeGuideType = element.getAttribute('data-sanitized-size-guide-type')
						}
						element.classList.add('hidden')
						if (sizeGuideType === selectedValue) {
							element.classList.remove('hidden')
						}
					})
				}
			}
		})
		tabBtns()
	} catch (err) {
		// console.log(err)
	}
}

SizeGuideOpenPage('.template-page .main-content')


function opentabAk(selector) {
	try {
		const tabs = document.querySelectorAll(selector)
		const tables = document.querySelectorAll('.table-container')
		tabs.forEach(btn => {
			btn.addEventListener('click', () => {
				btn.classList.toggle('active')
				const tabname = btn.getAttribute('data-sanitized-tabak')
				console.log(tabname)
				tables.forEach(t => {
					if (t.getAttribute('data-sanitized-tabak-table') === tabname && btn.classList.contains('active')) {
						t.style.display = "block"
					} else if (t.getAttribute('data-sanitized-tabak-table') === tabname) {
						t.style.display = "none"
					}
				})
			})
		})
	} catch (e) {
		console.error(e)
	}
}

opentabAk('.template-page .tab_ak')

function SizeGuideOpen(parentSelector) {
	try {

		const form = document.querySelector('#size-pd-chart .size-guides__form-selector')
		console.log(form)
		if (!form) {
			console.log('form not found')
			return
		}

		let tables = document.querySelectorAll('#size-pd-chart [size-guide-type]')

		if (tables.length == 0) {
			tables = document.querySelectorAll('#size-pd-chart [data-sanitized-size-guide-type]')
		}

		form.querySelectorAll('label').forEach(e => {
			e.addEventListener('click', () => {
				console.log(e.getAttribute('for'))
				form.querySelectorAll('input').forEach(el => {
					if (el.value == e.getAttribute('for')) {
						el.checked = true

						tables.forEach(t => {
							t.classList.add('hidden')
							if (el.value == t.getAttribute('size-guide-type') || el.value == t.getAttribute('data-sanitized-size-guide-type')) {
								t.classList.remove('hidden')
							}
						})
					} else {
						el.checked = false
					}
				})
			})
		})

		// form.addEventListener('change', function (event) {
		// 	if (event.target.type === 'radio') {
		// 		const selectedValue = event.target.value
		// 		console.log(`Selected unit: ${selectedValue}`)

		// 		const closestWrap = form.closest('.size-guides-wrapper')
		// 		if (closestWrap) {
		// 			closestWrap.querySelectorAll('[size-guide-type]').forEach(element => {
		// 				const sizeGuideType = element.getAttribute('size-guide-type')
		// 				element.classList.add('hidden')
		// 				if (sizeGuideType === selectedValue) {
		// 					element.classList.remove('hidden')
		// 				}
		// 			})
		// 		}
		// 	}
		// })
		tabBtns()
	} catch (err) {
		console.log(err)
	}
}

SizeGuideOpenPage('.template-page .main-content')


function openSizePopup(e) {
	let t = document.querySelector("#size-pd-chart")
	"" != e.trim() ? ((t.querySelector(".size-pd-chart-content").innerHTML = e), t.classList.add("show"), (document.querySelector("body").style.overflow = "hidden")) : alert("Size chart not found! May be this product has only ONE SIZE.")
	SizeGuideOpen('#size-pd-chart')
	opentabAk('.size-pd-chart-content .tab_ak')
	// setTimeout(SizeGuideOpen, 100, ".size-pd-chart-content"); 
}

function closeSizePopup() {
	document.querySelector("#size-pd-chart").classList.remove("show"), (document.querySelector("body").style.overflow = "")
}


function waitListReuest(e, t, l = null) {
	try {
		fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=PAgcrr", {
			headers: {
				accept: "application/vnd.api+json",
				"content-type": "application/vnd.api+json",
              'revision': "2024-10-15"
			},
			body: JSON.stringify({data:{
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": {
                    "data": {
                    "type": "profile",
                    "attributes": {
                          /*"id": "01GDDKASAP8TKDDA2GRZDSVP4H",*/
                          "email": e,
                          /*"external_id": "63f64a2b-c6bf-40c7-b81f-bed08162edbe"*/
                        }
                    }
                },
                "channels": [
                  "EMAIL"
                ]
              },
              "relationships": {
                "variant": {
                  "data": {
                    "type": "catalog-variant",
                    "id": "$shopify:::$default:::"+t
                  }
                },
                }
            }
            }),
			method: "POST",
		}).then((e) => {
				if ((e.status == 202)) {
					if ((console.log("waitlist true"), null != l)) {
						let e = l.closest(".product-upsell__holder")
						return (
							e.querySelector(".waitlist-modal_form").classList.add("hidden"),
							e.querySelector(".waitlist-modal_success").classList.add("show"),
							void setTimeout(function () {
								e.querySelector(".waitlist-modal_success").classList.remove("show"), (e.querySelector(".email_input").value = ""), e.querySelector(".waitlist-modal_form").classList.remove("hidden")
							}, 3e3)
						)
					}
					document.querySelector(".waitlist-modal_form").classList.add("hidden"), document.querySelector(".waitlist-modal_success").classList.add("show"), setTimeout(closeWaitList, 3e3)
				}
			})
			.catch((e) => {
				console.log(e)
			})
	} catch (e) {
		console.log(e)
	}
}


function waitListReuestOld(e, t, l = null) {
	try {
		fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions", {
			headers: {
				accept: "application/json, text/plain, */*",
				"content-type": "application/x-www-form-urlencoded;charset=UTF-8"
			},
			body: new URLSearchParams({ a: "PAgcrr", email: e, platform: "shopify", variant: t }),
			method: "POST",
		})
			.then((e) => {
				if ((console.log(e), 1 == e.ok)) {
					if ((console.log("waitlist true"), null != l)) {
						let e = l.closest(".product-upsell__holder")
						return (
							e.querySelector(".waitlist-modal_form").classList.add("hidden"),
							e.querySelector(".waitlist-modal_success").classList.add("show"),
							void setTimeout(function () {
								e.querySelector(".waitlist-modal_success").classList.remove("show"), (e.querySelector(".email_input").value = ""), e.querySelector(".waitlist-modal_form").classList.remove("hidden")
							}, 3e3)
						)
					}
					document.querySelector(".waitlist-modal_form").classList.add("hidden"), document.querySelector(".waitlist-modal_success").classList.add("show"), setTimeout(closeWaitList, 3e3)
				}
			})
			.catch((e) => {
				console.log(e)
			})
	} catch (e) {
		console.log(e)
	}
}

function closeWaitList() {
	document.querySelector(".waitlist-modal_form").classList.remove("hidden"),
		document.querySelector(".waitlist-modal_success").classList.remove("show"),
		(document.querySelector(".waitlist-modal-js").querySelector(".email_input").value = "")
}

function mySubmitFunction(e) {
	e.preventDefault()
	const t = e.target.elements.email.value,
		l = e.target.elements.id.value
	return console.log(t, l), waitListReuest(t, l), !1
}

function openModalWaitlist() {
	document.querySelector(".waitlist-modal-js").classList.add("show"), document.querySelector("#btn-waitlist-modal-show-js").classList.add("hidden")
}

function showAllLinksInDrawer(e) {
	e.closest(".mobile__menu__dropdown").classList.remove("is-hiding")
}

function changeVariantId(e, t, l) {
	let o = findIdVariantInJson(e, t);
	(l.closest(".product-upsell__holder").querySelector(".varId").value = o), console.log(l.closest(".product-upsell__holder").querySelector(".varId").value), closeWaitListUpsell(l)
}

function findIdVariantInJson(e, t) {
	let l = null
	return (
		e.variants.forEach((e) => {
			(e.option1 !== t && e.option2 !== t && e.option3 !== t) || (console.log(e.id), (l = e.id))
		}),
		l
	)
}

function openWaitListUpsell(e, t, l) {
	try {
		let o = findIdVariantInJson(e, t),
			s = l.closest(".product-upsell__holder")
		s.querySelector(".waitlist-modal-upsell-js").classList.add("show"),
			console.log(s.querySelector(".variantId_input").value),
			(s.querySelector(".variantId_input").value = o),
			s.querySelector(".btn--upsell-custom").classList.add("hidden")
	} catch (e) {
		console.log(e)
	}
	try {
		l.closest(".btn--upsell-mobile").querySelector("button").style.display = "none"
	} catch (e) {
		console.log(e)
	}
}

function closeWaitListUpsell(e) {
	try {
		let t = e.closest(".product-upsell__holder")
		t.querySelector(".waitlist-modal-upsell-js").classList.remove("show"), t.querySelector(".btn--upsell-custom").classList.remove("hidden"), t.querySelector(".waitlist-modal_form").classList.remove("hidden")
	} catch (e) {
		console.log(e)
	}
	try {
		e.closest(".btn--upsell-mobile").querySelector("button").style.display = "block"
	} catch (e) {
		console.log(e)
	}
}

function mySubmitFunctionUpsell(e, t) {
	e.preventDefault()
	const l = e.target.elements.email.value,
		o = e.target.elements.id.value
	return console.log(l, o), waitListReuest(l, o, t), !1
}

function selectChangeVariant(e, t, l) {
	if ((console.log(t), t.includes("sold"))) {
		let o = t.split(" ")[0]
		console.log(o), openWaitListUpsell(e, o, l)
	} else changeVariantId(e, t, l), closeWaitListUpsell(l)
}

document.querySelector("#size-pd-chart").addEventListener("click", function (e) {
	(!e.target.matches("#size-pd-chart") && e.target.closest(".show")) || closeSizePopup()
}),
	document.querySelectorAll(".sliderow--back").forEach((e) => {
		e.addEventListener("click", function (t) {
			t.preventDefault(),
				e.parentElement.classList.remove("is-visible"),
				showAllLinksInDrawer(e),
				e.classList.contains("link_level_next-1") &&
				document
					.querySelector(".drawer__menu")
					.querySelectorAll(".sliderow-firstlevel")
					.forEach((e) => {
						e.classList.remove("is-hiding")
					}),
				e.classList.contains("link_level_next-2") &&
				document
					.querySelector(".drawer__menu")
					.querySelectorAll(".btn_level-2")
					.forEach((e) => {
						e.classList.remove("is-hiding-hidden")
					})
		})
	}),
	document
		.querySelector(".drawer__menu")
		.querySelectorAll(".btn_level-2")
		.forEach((e) => {
			e.addEventListener("click", function () {
				document
					.querySelector(".drawer__menu")
					.querySelectorAll(".btn_level-2")
					.forEach((e) => {
						e.classList.add("is-hiding-hidden")
					})
			})
		}),
	document.querySelectorAll(".sliderow-firstlevel").forEach((e) => {
		e.addEventListener("click", function () {
			console.log("click"), document.querySelectorAll(".sliderow-firstlevel").forEach((e) => e.classList.add("is-hiding"))
		})
	}),
	(function(){"use strict";function e(e){if(!e)return;const t=document.querySelectorAll("[data-main-product-sale-badge]");if(!t.length)return;const n=e.compare_at_price||0,o=e.price||0;t.forEach(e=>{n>o&&o>0?(e.classList.remove("hide"),e.textContent=`-${Math.round((n-o)/n*100)}%`,e.setAttribute("data-sale-percentage",Math.round((n-o)/n*100).toString())):(e.classList.add("hide"),e.textContent="",e.setAttribute("data-sale-percentage","0"))})}function t(t){t.detail&&t.detail.variant&&setTimeout(()=>{e(t.detail.variant)},50)}document.addEventListener("theme:variant:change",t),document.querySelectorAll("[data-product]").forEach(n=>{n.addEventListener("theme:variant:change",t)})})()


function delHeadingsSizeGuidePages() {
	try {
		const heading = document.querySelector('.template-page .standard__heading')
		if (!heading) return
		if (heading.innerText.includes('SIZE GUIDE') || heading.innerText.includes('MEASUREMENTS')) {
			heading.style.display = 'none'
		}
	} catch (e) {
		console.error(e)
	}
}

delHeadingsSizeGuidePages()



class sizeGuideAccordion extends HTMLElement {
	constructor() {
		super()
		const iteam = this
		const header = this.querySelector('.accardion-size-guides__iteam_header')
		const content = this.querySelector('.accardion-size-guides__iteam_content')

		header.addEventListener('click', () => {
			if (content.classList.contains('hidden')) {
				content.classList.remove('hidden')
				header.classList.add('show')
			} else {
				content.classList.add('hidden')
				header.classList.remove('show')
			}
		})


		try {
			const form = iteam.querySelector('.size-guides__form-selector')

			if (!form) return

			let tables = iteam.querySelectorAll(' [size-guide-type]')

			if (tables.length == 0) {
				tables = iteam.querySelectorAll(' [data-sanitized-size-guide-type]')
			}

			form.querySelectorAll('label').forEach(e => {
				e.addEventListener('click', () => {
					console.log(e.getAttribute('for'))
					form.querySelectorAll('input').forEach(el => {
						console.log(el.value == e.getAttribute('for'))

						if (el.value == e.getAttribute('for')) {
							el.checked = true


							console.log('tables', tables)
							tables.forEach(t => {
								t.classList.add('hidden')
								if (el.value == t.getAttribute('size-guide-type') || el.value == t.getAttribute('data-sanitized-size-guide-type')) {
									t.classList.remove('hidden')
								}
							})
						} else {
							el.checked = false
						}
					})

					tabBtns()
				})
			})



		} catch (err) {
			console.log(err)
		}


	}
}

customElements.define('accardion-size-guides', sizeGuideAccordion);

window.upcartModifyCart = (cart) => {
  cart.items.forEach((item)=>{
    if (item.properties['DeliveryDate'] !== undefined){
          const shipDate = new Date(parseInt(item.properties['DeliveryDate']) * 1000);
          const month = shipDate.toLocaleString('en-US', { month: 'long' });
          const day = shipDate.getDate();
          const message = `ⓘ Will be shipped after ${month} ${day}th`;
          setMes(item.key,message);
    }
  })
}
window.upcartOnCartUpdated = (cartToShow) =>{
    cartToShow.items.forEach((item)=>{
    if (item.properties['DeliveryDate'] !== undefined){
          const shipDate = new Date(parseInt(item.properties['DeliveryDate']) * 1000);
          const month = shipDate.toLocaleString('en-US', { month: 'long' });
          const day = shipDate.getDate();
          const message = `ⓘ Will be shipped after ${month} ${day}th`;    
          setTimeout(()=>{setMes(item.key,message)},100);
    }
  })
}
function setMes(k, mes){
  let propStr = document.getElementById(k);
  if (propStr){
    propStr.querySelector('.upcart-item-property').innerText = mes;
  }
}